"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m8.015 5.748.891-2.26h1.076v.001h6.019v1H9.587l-.511 1.3.644 2.077-2.703 3.24-.194-3.723-1.583-1.52.712-1.374H0v-1h7.476l-.124.475-.877 1.695 1.327 1.276.082 1.566.717-.86-.586-1.893ZM2.397 8.69h-1.6v-1h1.6v1ZM16 12.431H.01v-1H16v1ZM3.573 8.691h2.39v-1h-2.39v1Zm8.915 0h-2.389v-1h2.389v1Zm1.178 0h1.601v-1h-1.6v1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m12.233 9.112 1.588-4.043h1.21l-.003.004h8.967V6.2h-9.408l-1.161 2.958.996 3.23-3.798 4.567-.28-5.376-2.427-2.341L9.485 6.2H0V5.073h9.896V5.07h1.15l-.288 1.12-1.455 2.818 2.14 2.066.154 2.949 1.57-1.888-.934-3.022Zm-6.986 3.933h3.305V11.92H5.247v1.125Zm-2.295 0H.888V11.92h2.064v1.125ZM0 18.928v-1.125l24-.009v1.126l-24 .008Zm18.803-5.883h-3.305V11.92h3.305v1.125Zm2.294 0h2.066V11.92h-2.066v1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m16.311 12.15 2.117-5.391h1.613l-.004.006h11.957v1.5H19.449l-1.548 3.944 1.328 4.308-5.064 6.088-.374-7.168-3.235-3.121 2.091-4.05H0V6.765h13.194l.001-.006h1.532l-.383 1.494-1.94 3.756 2.854 2.755.205 3.931 2.092-2.517-1.244-4.029Zm-9.315 5.243h4.407v-1.5H6.996v1.5Zm-3.06 0H1.185v-1.5h2.753v1.5ZM.002 25.237v-1.5l32-.012v1.501l-32 .011Zm25.066-7.843H20.66v-1.5h4.407v1.5Zm3.061 0h2.754v-1.5h-2.754v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M27.936 10.23H48v1.855H29.22l-2.52 6.389 1.997 6.443-7.269 8.698-.544-10.365-4.842-4.65 3.38-6.515H0V10.23h21.922l-.569 2.205-3.001 5.784 4.366 4.191.332 6.34 3.554-4.252-1.892-6.1 3.224-8.168ZM5.589 26.045H1.82V24.17h3.77v1.875ZM0 37.909v-1.875l48-.017v1.875L0 37.91Zm10.611-11.864h6.272V24.17h-6.272v1.875Zm26.945 0h-6.272V24.17h6.272v1.875Zm5.022 0h3.771V24.17h-3.771v1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M37.248 13.64H64v2.473H38.959l-3.36 8.518 2.664 8.591-9.692 11.597L27.845 31l-6.456-6.2 4.508-8.687H0V13.64h29.229l-.758 2.94-4.002 7.711 5.821 5.59.443 8.451 4.739-5.668-2.522-8.133 4.298-10.89ZM7.452 34.726H2.424v-2.5h5.028v2.5ZM0 50.546v-2.5l64-.023v2.5l-64 .023Zm14.148-15.82h8.363v-2.5h-8.363v2.5Zm35.926 0h-8.362v-2.5h8.362v2.5Zm6.697 0H61.8v-2.5h-5.028v2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconEarthquake = function IconEarthquake(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Earthquake' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Earthquake"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconEarthquake.sizes = [16, 24, 32, 48, 64];
IconEarthquake.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconEarthquake;
exports.default = _default;